"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionsApi = void 0;
const handlers_1 = require("../handlers");
exports.promotionsApi = (http, prefix = '/marketing-preferences') => ({
    getPromotionOpportunities(propertyId) {
        return http.get(`${prefix}/property/${propertyId}/opportunities`).catch(handlers_1._404([]));
    },
    getPromotionsByProperty(propertyId, channel) {
        const params = channel ? new URLSearchParams({ channel }) : undefined;
        return http.get(`${prefix}/property/${propertyId}/promotions`, params).catch(handlers_1._404([]));
    },
    createPromotionForProperty(propertyId, promotion) {
        return http.post(`${prefix}/property/${propertyId}/promotions`, promotion).catch(handlers_1._404([]));
    },
    deletePromotionForProperty(propertyId, promotion) {
        return http.delete(`${prefix}/property/${propertyId}/promotions/${promotion.id}`).catch(handlers_1._404([]));
    }
});
//# sourceMappingURL=index.js.map